import React from 'react';

import WsIconProps from './IconProps';

const DoubleTick: React.FC<WsIconProps> = ({ color = '#616893', width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2071 7.29289C16.5976 7.68342 16.5976 8.31658 16.2071 8.70711L8.56066 16.3536C7.97487 16.9393 7.02513 16.9393 6.43934 16.3536L3.29289 13.2071C2.90237 12.8166 2.90237 12.1834 3.29289 11.7929C3.68342 11.4024 4.31658 11.4024 4.70711 11.7929L7.5 14.5858L14.7929 7.29289C15.1834 6.90237 15.8166 6.90237 16.2071 7.29289Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L19.2929 7.29289C19.6834 6.90237 20.3166 6.90237 20.7071 7.29289Z"
      fill={color}
    />
  </svg>
);

export default DoubleTick;
